import { cn } from "utils";
import { EdgenModalCreateAble } from "../EdgenModal";
import { TAItems } from "../PortfolioTimeline";
import { TADetailWebModalCreateAbleProps } from "./types";
import { AgentReport } from "@/src/features/api/memberApi";

interface TADetailWebModalContentProps {
  data: AgentReport;
  onClose: () => void;
}

const TADetailWebModalContent = (props: TADetailWebModalContentProps) => {
  const { data, onClose } = props;
  return (
    <TAItems
      item={data}
      isExpanded={true}
      isPC={true}
      variant="modal"
      modalParams={{ onClose }}
    />
  );
};

export const TADetailWebModalCreateAble = async (
  props: TADetailWebModalCreateAbleProps,
) => {
  const { data } = props;

  const onClose = () => {
    EdgenModalCreateAble.end(false);
  };
  return new Promise(() => {
    EdgenModalCreateAble.call({
      children: <TADetailWebModalContent data={data} onClose={onClose} />,
      containerClassName: cn(
        "bg-background_solid_neutral_primary",
        "w-full w-[800px] h-[752px] px-6",
      ),
      contentStyle: {
        borderRadius: 16,
        width: "100%",
        height: "100%",
        padding: 0,
        overflow: "hidden",
      },
      containerStyle: {
        maxHeight: "100%",
      },
      destroyOnClose: true,
      onCancel: onClose,
      showClose: false,
    });
  });
};
